module.exports = __webpack_public_path__ + "img/redmaker1.c6e225e9.png";